// Case Converter Tool — transform text between common letter cases.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const caseConverterTool: Tool = {
  id: "case-converter",
  name: () => m.cc_tool_name(),
  description: () => m.cc_tool_description(),
  icon: "🔠",
  basePath: "/case-converter",
  status: "stable",
  tags: ["text", "case", "convert", "developer"],
  pages: [
    {
      name: () => m.cc_nav_main(),
      path: "/case-converter",
      description: () => m.cc_nav_main_desc(),
      icon: "🔠",
    },
  ],
};
